import React from 'react';

import styled from 'styled-components';

import { Row } from './Row';
import { sendBrazeEvent } from '../../../analytics/braze';
import { BR_SYSTEM_GA_DOWN_RETRY } from '../../../constants/braze/brazeEvents';
import { usePageMessages } from '../../../hooks/selectors';
import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';

const Container = styled.div`
    max-width: 400px;
    padding: 0 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: calc(100% - 48px);
`;

export const StubPage = () => {
    const { accountsNoConnectionTitle, tryAgain } = usePageMessages();

    const refreshPage = (e) => {
        e.preventDefault();
        sendBrazeEvent(BR_SYSTEM_GA_DOWN_RETRY);
        location.reload();
    };

    return (
        <Container>
            <Row indent="16px">
                <Icon name="tools" color="mediumGray" />
            </Row>
            <Text color="mediumGray" textCenter>
                {accountsNoConnectionTitle}
            </Text>
            <Button caption={tryAgain} variant="row" textCenter onClick={refreshPage} />
        </Container>
    );
};
